// extracted by mini-css-extract-plugin
module.exports = {"Tooltip":"Support_Tooltip__1PcKd","Code":"Support_Code__VbSKp"};